import React from 'react';
import { Col, Row, Container } from 'reactstrap';
import { Translate, withLocalize } from 'react-localize-redux';
import PropTypes from 'prop-types';

import LanguageButtons from './LanguageButtons';


function Header(props) {
  const { activeLanguage, chsite } = props;
  if (chsite.siteimage_set === undefined) {
    chsite.siteimage_set = [];
  }
  return (
    <Container>

      {chsite.siteimage_set.length === 3
          && (
          <Row
            className="justify-content-center"
            style={{ marginRight: '0', marginLeft: '0', marginBottom: '20px' }}
          >
            <div style={{ float: 'left', width: '33.33%' }}>
              <img src={chsite.siteimage_set[0].url} width="100%" alt="" />
            </div>
            <div style={{ float: 'left', width: '33.33%' }}>
              <img src={chsite.siteimage_set[1].url} width="100%" alt="" />
            </div>
            <div style={{ float: 'left', width: '33.33%' }}>
              <img src={chsite.siteimage_set[2].url} width="100%" alt="" />
            </div>
          </Row>
          )}

      {chsite.siteimage_set.length === 1
          && (
          <Row
            className="justify-content-center"
            style={{ marginRight: '0', marginLeft: '0', marginBottom: '20px' }}
          >
            <div style={{ float: 'left', width: '20%' }} />
            <div style={{ float: 'left', width: '60%' }}>
              <img src={chsite.siteimage_set[0].url} width="100%" alt="" />
            </div>
            <div style={{ float: 'left', width: '20%' }} />
          </Row>
          )}
      <Row
        className="justify-content-center"
        style={{ marginBottom: '28px' }}
      >
        <Col md="10" lg="10">
          <p className="greeting">
            <Translate id="header.improve" />
            {' '}
            {chsite.name}
            <Translate id="header.thank" />
          </p>
        </Col>
        <Col md="2" lg="2" className="text-right">
          <LanguageButtons />
        </Col>
      </Row>
    </Container>
  );
}

Header.propTypes = {
  activeLanguage: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
  chsite: PropTypes.shape({
    name: PropTypes.string.isRequired,
    siteimage_set: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
    })),
  }).isRequired,
};



export default withLocalize(Header);
